import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * A labelled form field — the same markup as Create Brief's Field
 * (modules/brand/components/screens/CreateBriefScreen.tsx): label row, the
 * hint above the input, the error below.
 */
export function StoreField({ label, hint, error, required, action, children }: {
    label: string;
    hint?: React.ReactNode;
    error?: string;
    required?: boolean;
    action?: React.ReactNode;
    children: React.ReactNode;
}) {
    return (
        <div className="brd-field">
            <div className="brd-field__label-row">
                <span className="brd-field__label">
                    {label}
                    {required ? <span className="brd-field__req"> *</span> : null}
                </span>
                {action}
            </div>
            {!!hint && <p className="brd-field__hint">{hint}</p>}
            {children}
            {!!error && <p className="brd-field__error" role="alert"><AlertCircle size={13} /> {error}</p>}
        </div>
    );
}
